import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { listStoreGroups } from "../graphql/queries/listStoreGroups";

export const useDistinctKeywordGroupsField = (field, type = "OUTLET") => {
  const { data, loading, error, refetch } = useQuery(listStoreGroups, {
    variables: { field, type },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: !field,
  });

  const options = useMemo(() => {
    return (data?.getDistinctKeywordGroupsField || [])
      .map((value) => ({ id: String(value), displayText: String(value) }))
      .sort((a, b) => a.displayText.localeCompare(b.displayText));
  }, [data]);

  return { options, loading, error, refetch };
};
